import $ from 'jquery'

import OrderSuggestions from '../validation/OrderSuggestions'
import Dropdown from '../components/Dropdown'
import Translation from '../i18n/Translation'
import Util from '../util/Util'
import OrderValidation from '../validation/OrderValidation'
import RequestDialog from '../components/RequestDialog'


export default class Order {
  static prefix = 'vol_orders_'

  static _registerEvents () {
    $(document).on('click', '.remove-deliverpoint', Order._removeDeliverPoint)

    $('#add-delivery-point').click((event) => {
      event.preventDefault()

      Order._addDeliveryPoint()
    })

    $('.dialog-background').on('click', event => {
      $(event.target).siblings('.dialog').find('.close-dialog').trigger('click')
    })

    $('.close-dialog').click((event) => {
      event.preventDefault()

      const toggleElement = event.target.dataset.toggle
      const element = document.getElementById(toggleElement)

      element.classList.add('hidden')

      $(document.body).removeClass('fade')
    })

    $('#open-dialog').click((event) => {
      const toggleElement = event.target.dataset.elementid
      const element = document.getElementById(toggleElement)

      $('body, html').animate({ scrollTop: 0 }, 500, 'swing')

      // $(window).scrollTop({ top: 0, behavior: 'smooth' })
      element.classList.remove('hidden')

      $(document.body).addClass('fade')
    })
  }

  static _clearDeliveryPointData (index) {
    Object.keys(localStorage)
      .filter(key => key.includes(`[${index}]`))
      .forEach(key => localStorage.removeItem(key))

    Order._getAllLocalStorageIds().forEach((oldIndex, currentIndex) => {
      Object.keys(localStorage).forEach(key => {
        if (key.includes(`[${oldIndex}]`)) {
          const newKey = key.replace(oldIndex, currentIndex)
          localStorage.setItem(newKey, localStorage[key])

          if (oldIndex !== currentIndex) {
            localStorage.removeItem(key)
          }
        }
      })
    })

    $('#delivery-points').html('')
    Order._recreateForms(true)
  }

  static _removeDeliverPoint (event) {
    const { deliverypointIndex } = event.target.dataset
    const ids = Array.from(document.getElementsByClassName('consumptionpoint_internal_id')).map(input => input.value)

    if (ids.length > 0) {
      const id = ids[deliverypointIndex]

      $.ajax({
        type: 'POST',
        // eslint-disable-next-line max-len
        url: '/bestellprozess?tx_voltego_orders%5Baction%5D=deleteconsumptionpoint&tx_voltego_orders%5Bcontroller%5D=Ajax&type=1335898897',
        contentType: 'application/x-www-form-urlencoded',
        data: `consumptionpoint_id=${id}`,
        success: ({ success, message }) => {
          // eslint-disable-next-line no-console

          const idInput = document.querySelector(`.consumptionpoint_internal_id[value="${id}"]`)

          if (idInput) {
            idInput.remove()
          }

          Order._clearDeliveryPointData(deliverypointIndex)
        },
        error: (error) => {
          // eslint-disable-next-line no-console
          console.error(error)
        },
      })

      return
    }

    Order._clearDeliveryPointData(deliverypointIndex)
  }

  static _addDeliveryPoint (suppressMessage = true) {
    const originalDeliverPoint = document.getElementById('deliver-point-original')
    const deliveryPoints = document.getElementById('delivery-points')

    if (!deliveryPoints) {
      return
    }

    const index = deliveryPoints.querySelectorAll('.card').length

    if (index === 1 && !suppressMessage) {
      const helpDialog = document.getElementById('help-dialog')

      helpDialog.classList.remove('hidden')
      $(document.body).addClass('fade')
    }

    if (index > 0) {
      $('.remove-deliverpoint').removeClass('hidden')
    }
    else {
      $('.remove-deliverpoint').addClass('hidden')
    }

    deliveryPoints.innerHTML += originalDeliverPoint.innerHTML.replace(/#i#/g, index + 1).replace(/#index#/g, index)
    Order._recreateForms()
  }

  static _getFormInputKeys (key) {
    const fields = [
      ...(document.getElementsByTagName('input') || []),
      ...(document.getElementsByTagName('textarea') || []),
    ]

    switch (key) {
      case 'consumptionpoints':
        return fields
          .filter(input =>
            (input.name.includes(`${Order.prefix}`) && !input.name.includes('#index#'))
          )
          .map(input => input.name)
          .filter((elem, index, self) => index === self.indexOf(elem))

      case 'overview':
      case 'connectiondata':
          //alert("test3333333333");
          const indices = Order._getAllLocalStorageIds()
          indices.forEach((index) => {
              const keyName = `vol_orders_connectiondata_old_contract_canceled[${index}]`
              //alert(JSON.stringify(keyName));
              var radios = document.getElementsByName(keyName);
             // alert(JSON.stringify(radios));
              for (var radio of radios) {
                  if (radio.checked) {
                     // alert(radio.value);
                      if(radio.value === "none"){
                          var bvalue = document.querySelector("input[list=browsers]").value;
                         // alert(bvalue);
                          if(bvalue == null || bvalue == ""){
                              document.getElementById("diverrorsuplier").style.display = "block";
                              document.getElementById("divvorver").style.color = "red";
                              document.querySelector("input[list=browsers]").style.border = "2px solid red";
                             // alert("retunr false");
                              event.disabled = false;

                              event.preventDefault();
                              stopPropagation();

                              return false;
                          }else{
                              //alert("not empty");
                          }
                      }
                  }
              }

              //const val = localStorage.getItem(keyName)

              //OrderValidation.handleConsumptionType(keyName, Util.getNumberFromSeparatedNumberString(val))
          })
      case 'contract':
        return fields
          .filter(input => input.name.includes(`${Order.prefix}${key}`) && !input.name.includes('#index#'))
          .map(input => input.name)
          .filter((elem, index, self) => index === self.indexOf(elem))

      default:
        return true
    }
  }

  static _registerInputChange () {
    OrderSuggestions.registerEvents()

    $(document).on('change', 'input', async (event, validate = true) => {
      const { name, value, checked } = event.target
      let val = String(value).trim()
      event.target.value = val

      if (name == "vol_orders_contract_company") {
        event.target.value = Order._filterCompanyName(value)
        val = Order._filterCompanyName(value)
      }
      if (name == "vol_orders_contract_company_type") {

        $(".contact-person-headline").text("Ansprechpartner")
        $(".einzelunternehmen-extra-fields").addClass("full-hidden")
        if (value == "Einzelunternehmen") {
          $(".einzelunternehmen-extra-fields").removeClass("full-hidden")
          $(".contact-person-headline").text("Inhaber")
        }
      }

      const index = Util._getCurrentIndex(name)

      if (index === '#' || index === '#index#') {
        return
      }

      if (event.target.type === 'checkbox') {
        val = checked
      }

      if (name === 'vol_orders_start_date' && !val) {
        event.target.value = Translation.getText('asap')
      }

      if (name.includes('vol_orders_consumptionpoint_meter_type')) {
        val = val ? 'EXPORT' : 'MAIN'
      }
        if (name.includes('consumptionpoint_cls_adapter')) {
            const inputNamecls = `vol_orders_consumptionpoint_meter_installation[${index}]`
            const inputchk = `clschkbox${index}`
            if(document.getElementById(inputchk).checked == true) {
                localStorage.setItem(inputNamecls, 'installation_request')
            }else {
            }
        }

      if (name.includes('consumption_amount')) {
        val = Util.getNumberFromSeparatedNumberString(value)

        OrderValidation.handleConsumptionType(name, Util.getNumberFromSeparatedNumberString(value))

        const inputName = `vol_orders_consumptionpoint_consumption_type[${index}]`

        if (val >= 100000) {
          document.getElementsByName(inputName).forEach(input => {
            input.checked = input.value === 'RLM'
          })

          localStorage.setItem(inputName, 'RLM')

          OrderValidation.hideConsumptionType(false, index)
        }
        else if (val < 60000) {
          document.getElementsByName(inputName).forEach(input => {
            input.checked = input.value === 'SLP'
          })

          localStorage.setItem(inputName, 'SLP')

          OrderValidation.hideConsumptionType(true, index)
        }
      }

      if (name === 'vol_orders_customer_type' && value !== 'private') {
        const indices = Order._getAllLocalStorageIds()

        indices.forEach((index) => {
          const keyName = `vol_orders_consumptionpoint_consumption_amount[${index}]`
          const val = localStorage.getItem(keyName)

          OrderValidation.handleConsumptionType(keyName, Util.getNumberFromSeparatedNumberString(val))
        })
      }

      localStorage.setItem(name, val)

      if (name.includes('consumption_type') || name.includes('medium_type')) {
        OrderValidation.loadIndustrySectors(name)
      }

      OrderValidation.handleField(name)

      if (name.includes('vol_orders_consumptionpoint_consumption_type')) {
        const index = Util._getCurrentIndex(name)
        const validationName = `vol_orders_consumptionpoint_consumption_amount[${index}]`
        const { success, message } = await OrderValidation.isTypeValid(validationName, localStorage[validationName])

        OrderValidation.setInputError(!success, validationName, message)
      }

      if (validate) {
        const { success, message } = await OrderValidation.validateInput(name, value)

        OrderValidation.setInputError(!success, name, message)
      }
    })

    $(document).on('change', 'textarea', async (event, validate = true) => {
      const { name, value } = event.target
      const { success, message } = await OrderValidation.validateInput(name, value)

      if (validate) {
        OrderValidation.setInputError(!success, name, message)
        localStorage.setItem(`${name}`, value)
      }
    })
  }

  static async _recreateForms (init = false) {
    if (init) {
      Order._getConsumptionPointsIds()
    }

    const currentPageIndex = window.location.search.substring(window.location.search.indexOf('=') + 1)

    if (currentPageIndex === '1' || !currentPageIndex) {
      await OrderValidation.loadIndustrySectors('init')
    }

    const inputs = [
      ...(document.getElementsByTagName('input') || []),
      ...(document.getElementsByTagName('textarea') || []),
    ]

    const defaultStr = localStorage.getItem("url_defaults")
    let urlDefaults = null
    if (defaultStr) {
      urlDefaults = JSON.parse(defaultStr)
    }

    inputs.forEach(input => {
      if (
        input.name &&
        !input.name.includes('#index#') &&
        !input.name.includes('vol_orders_connectiondata_internal_id')
      ) {

        let inputValue = localStorage[input.name] || input.value
        if (urlDefaults) {
          let q = urlDefaults[input.name]
          if (q) {
            if (inputValue == "") {
              inputValue = q
            }
          }
        }

        if (input.type === 'checkbox' && !input.name.includes('vol_orders_consumptionpoint_meter_type')) {
          input.checked = localStorage[input.name] === 'true'
        }
        else if (input.type === 'radio') {
          const isNotSet = !localStorage[input.name] &&
            Array.from(document.querySelectorAll(`[name="${input.name}"]`)).findIndex(radio => radio === input) === 0

          input.checked = localStorage[input.name] === input.value || isNotSet

          if (isNotSet) {
            localStorage.setItem(input.name, input.value)
          }
        }
        else if (input.type === 'hidden' && input.classList.contains('hidden-dropdown')) {
          input.value = inputValue

          Dropdown._changeSelected(input.name, inputValue)
        }
        else if (input.name.includes('vol_orders_consumptionpoint_consumption_amount')) {
          input.value = Util.getSeparatedNumberString(inputValue)
        }
        else if (input.name.includes('vol_orders_consumptionpoint_meter_type') && input.value === 'EXPORT') {
          input.checked = localStorage[input.name] === 'EXPORT'
        }
        else {
          input.value = inputValue
        }

        OrderValidation.handleField(input.name)
      }

      if (!localStorage[input.name] && !input.name.includes('#index#')) {
        $(input).trigger('change', false)
      }

      if (input.name.includes('vol_orders_connectiondata_internal_id')) {
        localStorage.setItem(input.name, input.value)
      }
    })
  }

  static _getAllLocalStorageIds () {
    return Object.keys(localStorage)
      .filter(key => /^vol_orders_\w*\[\d+\]/.test(key))
      .map(key => Number(key.slice(-2, -1)))
      .filter((value, index, self) => self.indexOf(value) === index)
      .sort()
  }

  static _getConsumptionPointsIds () {
    let ids = [ ...(document.getElementsByClassName('consumptionpoint_internal_id') || []) ].map(input => input.value)

    ids = ids.length === 0 ? Order._getAllLocalStorageIds() : ids

    if (ids.length === 0) {
      Order._addDeliveryPoint()
    }
    else {
      ids.forEach((id, index) => {
        Order._addDeliveryPoint(true)
      })
    }
  }

  static _loadingAnimation (show, terminationMode = false) {
    if (show) {
      $('#loading-dialog').removeClass('hidden')
      $(document.body).addClass('fade')

      const step = window.location.search.split('=')[1] || '1'

      $('.step-0-loading-text').addClass('hidden')
      $('.step-1-loading-text').addClass('hidden')
      $('.step-4-loading-text').addClass('hidden')

      if (terminationMode == true) {
        $('.step-0-loading-text').removeClass('hidden')
      } else if (step === '1') {
        $('.step-1-loading-text').removeClass('hidden')
      } else {
        $('.step-4-loading-text').removeClass('hidden')
      }
    }
    else {
      $('#loading-dialog').addClass('hidden')
      $(document.body).removeClass('fade')
    }
  }

  static _handleErrorDialog (show, message, description, icon) {
    if (show) {
      $('#error-dialog').removeClass('hidden')
      $(document.body).addClass('fade')

      if (message) {
        $('#error-dialog .dialog-title').html(message)
      }

      if (description) {
        $('#error-dialog .dialog-description').html(description)
      }

      if (icon) {
        $('.dialog-icon').addClass('hidden')
        $(`#icon-${icon}`).removeClass('hidden')
      }
    }
    else {
      $('#error-dialog').addClass('hidden')
      $(document.body).removeClass('fade')
      $('#error-dialog .dialog-title').html(Translation.getText('order_dialog_message_default'))
      $('#error-dialog .dialog-description').html(Translation.getText('order_dialog_description_default'))
      $('.dialog-icon').addClass('hidden')
      $('#icon-default').removeClass('hidden')
    }
  }

  static async _validateForm (inputKeys) {

    const validation = []

    for (const key of inputKeys) {

      const { success, message } = await OrderValidation.validateInput(key, localStorage[key])

      OrderValidation.setInputError(!success, key, message)

      validation.push(success)
    }

    return !validation.includes(false)
  }

  static _setAddressError (hasError, consumptionPointsIndices) {
    // remove all (old) messages
    $('.vol_orders_consumptionpoint_address').each(function () {
      $(this).text('')
    })

    if (hasError) {
      consumptionPointsIndices.forEach(index => {
        $(`.vol_orders_consumptionpoint_address_${index}`).text(Translation.getText('no_operators_address'))
      })
    }
  }

  static async _submitFunction (inputPrefix, nextStopId) {
    const formInputKeys = Order._getFormInputKeys(inputPrefix)
    const validationSuccessful = await Order._validateForm(formInputKeys)

    if (validationSuccessful) {
      let inputValues = {}
      let dataString = `vol_cookie_consent_allowed=${localStorage.vol_cookie_consent_allowed}&`
      formInputKeys.forEach((key, index) => {
        inputValues = {
          ...inputValues,
          [key]: localStorage[key],
        }

        dataString += `${key}=${encodeURIComponent(localStorage[key])}${index !== formInputKeys.length - 1 ? '&' : ''}`
      })

      // eslint-disable-next-line max-len
      const url = `/bestellprozess?tx_voltego_orders%5Baction%5D=${inputPrefix}&tx_voltego_orders%5Bcontroller%5D=Ajax&type=1335898897`

      Order._loadingAnimation(true)

      $.ajax({
        type: 'POST',
        url,
        contentType: 'application/x-www-form-urlencoded',
        data: dataString,
        success: ({ success, message, display_message: displayMessage, ...rest }) => {
          Order._setAddressError(false)

          if (success) {
            if (nextStopId === 'finish') {
              localStorage.setItem('vol_orders_finish_status', message)

              // Linkedin
              window.lintrk('track', { conversion_id: 11785364 })

              setTimeout( ()=> {
                window.location = '/'
              }, 800)

              return
            }

            window.location.search = `?step=${nextStopId}`
          }
          else {
            Order._loadingAnimation(false)

            if (rest.status_code === 400 || !displayMessage) {
              let message = Translation.getText('order_dialog_message_default')
              let description = Translation.getText('order_dialog_description_default')
              let icon = 'default'

              switch (rest.error_code) {
                case 10:
                  message = Translation.getText('order_dialog_message_invalid-address')
                  description = Translation.getText('order_dialog_description_invalid-address')
                  icon = 'no-operators'
                  break
                case 11:
                  message = Translation.getText('order_dialog_message_no-operators')
                  description = Translation.getText('order_dialog_description_no-operators')
                  icon = 'no-operators'
                  break
                case 12:
                  message = Translation.getText('order_dialog_message_no-tariffs')
                  description = Translation.getText('order_dialog_description_no-tariffs')
                  icon = 'no-operators'
                  break
              }

              Order._handleErrorDialog(true, message, description, icon)

              return
            }

            Order._handleErrorDialog(true, displayMessage)
          }
        },
        error: (error) => {
          Order._loadingAnimation(false)
          // eslint-disable-next-line no-console
          console.error(error)
          Order._handleErrorDialog(true)
        },
      })
    }
  }

  static _initTerminationSubmit () {
    $('#termination_submit').click((event) => {
      event.preventDefault();


    //const validationSuccessful = true;
    let formInputKeys = ['vol_termination_customer_nr',
                         'vol_termination_contract_nr',
                         'vol_termination_reason',
                         'vol_termination_meter_identifier',
                         'vol_termination_address',
                         'vol_termination_contract_type',
                         'vol_termination_notes'];

      let valState = Order._validateForm(formInputKeys)

      valState.then((val)=> {
        if (val == true) {
          RequestDialog.show()
          }
      })
    });

    $('.close-dialog').click((event) => {
      event.preventDefault()

      const toggleElement = event.target.dataset.toggle
      const element = document.getElementById(toggleElement)

      element.classList.add('hidden')

      $(document.body).removeClass('fade')
    })
  }

  static async _submitTerminationFunction () {
    const inputPrefix = 'terminatecontract'

    //const validationSuccessful = true;
    let formInputKeys = ['vol_termination_customer_nr',
                         'vol_termination_contract_nr',
                         'vol_termination_reason',
                         'vol_termination_meter_identifier',
                         'vol_termination_address',
                         'vol_termination_contract_type',
                         'vol_termination_notes'];



    const validationSuccessful = await Order._validateForm(formInputKeys)


    if (validationSuccessful) {
      let inputValues = {}
      let dataString = `vol_cookie_consent_allowed=${localStorage.vol_cookie_consent_allowed}&`


      formInputKeys.forEach((key, index) => {
        inputValues = {
          ...inputValues,
          [key]: localStorage[key],
        }

        dataString += `${key}=${encodeURIComponent(localStorage[key])}${index !== formInputKeys.length - 1 ? '&' : ''}`
      })

      // eslint-disable-next-line max-len
      const url = `/bestellprozess?tx_voltego_orders%5Baction%5D=${inputPrefix}&tx_voltego_orders%5Bcontroller%5D=Ajax&type=1335898897`

      Order._loadingAnimation(true,true)

      $.ajax({
        type: 'POST',
        url,
        contentType: 'application/x-www-form-urlencoded',
        data: dataString,
        success: ({ success, message, display_message: displayMessage, ...rest }) => {

          if (success) {
            //if (nextStopId === 'finish') {
              //localStorage.setItem('vol_orders_finish_status', message)
              //window.location = '/'
              //return
            //}

            //window.location.search = `?step=${nextStopId}`
          }
          else {
            Order._loadingAnimation(false)

            if (rest.status_code === 400 || !displayMessage) {
              let message = Translation.getText('order_dialog_message_default')
              let description = Translation.getText('order_dialog_description_default')
              let icon = 'default'

              switch (rest.error_code) {
                case 10:
                  message = " ";
                  description = "Wir konnten zu Ihren Angaben leider keinen Vertrag finden, bitte prüfen Sie Ihre Eingaben. Sollte das Problem bestehen bleiben wenden Sie sich bitte an unseren Support.";
                  icon = 'no-operators'
                  break

                case 11:
                  message = "Kündigungsanfrage";
                  description = "Ihre Kündigung ist bei uns eingegangen und wird in Kürze bearbeitet. Der Kündigungstermin wird in einer separaten Nachricht bestätigt.";
                  icon = 'no-operators'
                  break
              }

              Order._handleErrorDialog(true, message, description, icon)

              return
            }

            Order._handleErrorDialog(true, displayMessage)
          }
        },
        error: (error) => {
          Order._loadingAnimation(false)
          // eslint-disable-next-line no-console
          console.error(error)
          Order._handleErrorDialog(true)
        },
      })
    }
  }




  static _onSubmit () {
    $('#submit').click((event) => {
      event.preventDefault()

      const currentPageIndex = window.location.search.substring(window.location.search.indexOf('=') + 1)

      switch (currentPageIndex) {
        case '1':
          Order._submitFunction('consumptionpoints', 2)
          break
        case '2':
          window.location.search = '?step=3'
          break
        case '3':
          Order._submitFunction('contract', 4)
          break
        case '4':
          Order._submitFunction('connectiondata', 5)
          break
        case '5':
          Order._submitFunction('overview', 'finish')
          break
        default:
          Order._submitFunction('consumptionpoints', 2)
          break
      }
    })
  }

  static _setOverviewData () {

    let doc = ""
    $('.voltego-text-footer a').each( function(index) {
      let label = this.innerText;
      if (label.indexOf("Tarif") != -1)
        doc = this.href
    });

    let link = $('#vol_orders_overview_agb_container a')[0]
    if (link)
      link.href= doc

    $('.vol_orders_contract_firstname').html(localStorage.vol_orders_contract_firstname)
    $('.vol_orders_contract_lastname').html(localStorage.vol_orders_contract_lastname)
    $('.vol_orders_contract_phone').html(localStorage.vol_orders_contract_phone)
    $('.vol_orders_contract_email').html(localStorage.vol_orders_contract_email)

    $('.vol_orders_contract_company').html(localStorage.vol_orders_contract_company)

    if (localStorage.vol_orders_contract_company_type !== 'Einzelunternehmen') {
      $('.vol_orders_contract_company_type').html(localStorage.vol_orders_contract_company_type)
    }

    if (localStorage.vol_orders_contract_company_type === 'GmbH-Co-KG') {
      $('.vol_orders_contract_company_type').html('GmbH & Co. KG')
    }

    $('.vol_orders_contract_city').html(localStorage.vol_orders_contract_city)
    $('.vol_orders_contract_postal_code').html(localStorage.vol_orders_contract_postal_code)
    $('.vol_orders_contract_street').html(localStorage.vol_orders_contract_street)
    $('.vol_orders_contract_house_number').html(localStorage.vol_orders_contract_house_number)
  }

  static _filterCompanyName(name) {

    let arr = ['GmbH',
               'Partnergesellschaft mbB',
               'Einzelunternehmen',
               'GmbH & Co. KG',
               'GbR',
               'UG',
               'KG',
               'oHG',
               'Limited',
               'AG',
               'eingetragene Genossenschaft (eG)',

               'Körperschaft des öffentlichen Rechts',
               'Stille Gesellschaft (StGes)',
               'Kommanditgesellschaft auf Aktien (KGaA)',
               'Europäische Aktiengesellschaft / Societas Europaea (SE)',
               'Eingetragene Kauffrau (e. Kfr.)',
               'eingetragener Kaufmann (e. Kfm.)',
               'GmbH & Co OHG'
              ]

    arr.forEach((e)=> {
      name = name.replace(e,'')
    })

    name = name.trim()
    return name
  }


  static _clear () {
    Object
      .keys(localStorage)
      .filter(key => key.includes('vol_orders'))
      .forEach(key => localStorage.removeItem(key))
  }

  static _handleReferrer () {
    const { referrer } = document

    if (referrer && !referrer.includes('bestellprozess')) {
      localStorage.setItem('bestellprozess_referrer', referrer + window.location.hash)

      // on entering the order process clear old data
      Order._clear()
    }

    const storedReferer = localStorage.getItem('bestellprozess_referrer') || '/'

    $('#abort_link').attr('href', storedReferer)
  }

  static init () {
    const orderWrapper = document.querySelector('#form-order')

    if (orderWrapper) {
      OrderValidation.setMode("orders")

      if (document.querySelector('#abort_link')) {
        Order._handleReferrer()
      }

      Order._recreateForms(true)
      Order._registerEvents()
      Order._onSubmit()
      Order._registerInputChange()
      Order._setOverviewData()
      OrderValidation.handleField()
    } else {
      Order._registerInputChange()
      OrderValidation.handleField()
      Order._initTerminationSubmit()
    }

    const termWrapper = document.querySelector('#termination')

    if (termWrapper) {
      Order._recreateForms(true)
      Order._registerInputChange()
      OrderValidation.handleField()
      Order._initTerminationSubmit()
    }

  }
}
